import 'sanitize.css';
import 'src/styles/static-global.scss';

import { WrapPageElement, WrapRootElement } from '../src/components';

export const wrapRootElement = WrapRootElement;
export const wrapPageElement = WrapPageElement;
